const SILENT_SUCCESS_FORM_KEYS = new Set([
	'entryInventory',
	'tranferInventory',
	'transferInventory',
]);

export const shouldShowFormSuccessToast = formKey =>
	!SILENT_SUCCESS_FORM_KEYS.has(formKey);

export const getElementViewPayload = (
	{ elementViewId, oWarehouseId, elementViewKey, transaction } = {},
	elementViewKeys = {},
) => {
	const resolvedElementViewKey = elementViewKeys[elementViewKey];

	if (!elementViewId && !resolvedElementViewKey && !oWarehouseId) return null;

	return {
		elementId: elementViewId,
		oWarehouseId,
		transaction,
		elementViewKey: resolvedElementViewKey,
	};
};
